import isPropValid from '@emotion/is-prop-valid';

const filterHtmlProps = (props, exclude = []) => Object.entries(props).filter(([key]) => isPropValid(key)).filter(([key]) => isPropToInclude(exclude, key)).reduce((acc, [key, value]) => Object.assign(acc, {
  [key]: value
}), {});

const isPropToInclude = (exclude, key) => {
  return !exclude.includes(key);
};

export default filterHtmlProps;